import { Clazz } from "../../types";
import ClazzService from "../../services/Clazz";

import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

import { QUERY_KEY } from "./useListClazzes";

export const makeQueryKey = (id?: Clazz["id"]) => [QUERY_KEY, id];

function useFetchClazz(id?: Clazz["id"]) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return ClazzService.fetchClazz(id);
      }

      throw new Error("clazz id is required");
    },
    {
      enabled: !!id,
    }
  );
}

export default useFetchClazz;
